// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__EY5Qx","modalContent":"Modal_modalContent__JODE3","close":"Modal_close__nnot4"};